<template>
  <div>
    <b-modal id="modalEditInventoryProfiles" ref="modalEditInventoryProfiles" :title="$t('Switch profile')" hide-footer size="lg">
      <div v-if="editItem">
        <div>
          <b-tabs pills vertical card content-class="mt-3">
            <b-tab :title="$t('Main')" active>
              <b-form-group label-align="right" label='ID' label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="editItem.id > 0">
                <b-form-input type="text" disabled v-model="editItem.id"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Profile name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input  type="text" v-model="editItem.name" aria-describedby="inputFeedbackName" :state="editItem.name.length > 0"/>
                <b-form-invalid-feedback id="inputFeedbackName">
                    {{ $t('Enter title') }}
                </b-form-invalid-feedback>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Ports capacity')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="text" v-model="editItem.supp_volumes" placeholder="8,16,24" aria-describedby="inputFeedbackPorts" :state="editItem.supp_volumes.length > 0"/>
                <b-form-invalid-feedback id="inputFeedbackPorts"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Ports start with 0')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-checkbox v-model="editItem.port_start_offset"  value="0" unchecked-value="1"></b-checkbox>
              </b-form-group>
            </b-tab>
            <b-tab :title="$t('Remote ID')" >
              <b-form-group label-align="right" :label="$t('Enable')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-checkbox v-model="editItem.isEnableTabRemoteID"></b-checkbox>
              </b-form-group>
              <b-form-group  v-if="editItem.isEnableTabRemoteID">
                <b-form-group label-align="right" :label="$t('Type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-select :options="remoteIDselectType" v-model="editItem.tec_id_meta.type"></b-form-select>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Disposition')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-select :options="remoteIDselectDis" v-model="editItem.tec_id_meta.disposition"></b-form-select>
                </b-form-group>
                <b-form-group label-align="right" :label="editItem.tec_id_meta.type != 5 ? $t('Offset') : $t('Found value position(starts from 0)')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-input type="number" v-model="editItem.tec_id_meta.offset"/>
                </b-form-group>
                <b-form-group v-if="editItem.tec_id_meta.type != 5" label-align="right" :label="$t('Length')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-input type="number" v-model="editItem.tec_id_meta.len"/>
                </b-form-group>
                <b-form-group v-if="editItem.tec_id_meta.type == 5" label-align="right" :label="$t('Regex')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-input type="text" v-model="editItem.tec_id_meta.regex"/>
                </b-form-group>
              </b-form-group>
            </b-tab>
            <b-tab :title="$t('Port ID')">
              <b-form-group label-align="right" :label="$t('Enable')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-checkbox v-model="editItem.isEnableTabPortID"></b-checkbox>
              </b-form-group>
              <b-form-group  v-if="editItem.isEnableTabPortID">
                <b-form-group label-align="right" :label="$t('Type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-select :options="portSelectType" v-model="editItem.port_id_meta.type"></b-form-select>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Disposition')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-select :options="remoteIDselectDis" v-model="editItem.port_id_meta.disposition"></b-form-select>
                </b-form-group>
                <b-form-group label-align="right" :label="editItem.port_id_meta.type != 5 ? $t('Offset') : $t('Found value position(starts from 0)')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-input type="number" v-model="editItem.port_id_meta.offset"/>
                </b-form-group>
                <b-form-group v-if="editItem.port_id_meta.type != 5" label-align="right" :label="$t('Length')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-input type="number" v-model="editItem.port_id_meta.len"/>
                </b-form-group>
                <b-form-group v-if="editItem.port_id_meta.type == 5" label-align="right" :label="$t('Regex')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-input type="text" v-model="editItem.port_id_meta.regex"/>
                </b-form-group>
              </b-form-group>
            </b-tab>
            <b-tab :title="$t('VLAN ID')">
              <b-form-group label-align="right" :label="$t('Enable')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-checkbox v-model="editItem.isEnableTabVlanID"></b-checkbox>
              </b-form-group>
              <b-form-group  v-if="editItem.isEnableTabVlanID">
                <b-form-group label-align="right" :label="$t('Type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-select :options="portSelectType" v-model="editItem.vlan_id_meta.type"></b-form-select>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Disposition')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-select :options="remoteIDselectDis" v-model="editItem.vlan_id_meta.disposition"></b-form-select>
                </b-form-group>
                <b-form-group label-align="right" :label="editItem.vlan_id_meta.type != 5 ? $t('Offset') : $t('Found value position(starts from 0)')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-input type="number" v-model="editItem.vlan_id_meta.offset"/>
                </b-form-group>
                <b-form-group v-if="editItem.vlan_id_meta.type != 5" label-align="right" :label="$t('Length')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-input type="number" v-model="editItem.vlan_id_meta.len"/>
                </b-form-group>
                <b-form-group v-if="editItem.vlan_id_meta.type == 5" label-align="right" :label="$t('Regex')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-input type="text" v-model="editItem.vlan_id_meta.regex"/>
                </b-form-group>
              </b-form-group>
            </b-tab>
          </b-tabs>
        </div>

        <modal-ok-cancel @save="saveProfile" @cancel="$bvModal.hide('modalEditInventoryProfiles')" size="lg"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  data () {
    return {
      remoteIDselectType: [
        { value: 1, text: 'String' },
        { value: 2, text: 'Binary' },
        { value: 5, text: 'String regex' }
      ],
      remoteIDselectDis: [
        { value: 1, text: 'Option 82' },
        { value: 2, text: 'Agent circuit ID' },
        { value: 3, text: 'Agent remote ID' }
      ],
      portSelectType: [
        { value: 1, text: 'String' },
        { value: 3, text: 'Binary (LE)' },
        { value: 4, text: 'Binary (BE)' },
        { value: 5, text: 'String regex' }
      ]
    }
  },
  methods: {
    saveProfile () {
      if (!this.editItem.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field Profile name'), 'Error')
        return
      }
      if (!this.editItem.supp_volumes) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field Ports capacity'), 'Error')
        return
      }
      if (!this.editItem.isEnableTabPortID) {
        this.editItem.port_id_meta.offset = 0
        this.editItem.port_id_meta.len = 0
        this.editItem.port_id_meta.type = 0
        this.editItem.port_id_meta.disposition = 0
        this.editItem.port_id_meta.regex = ''
      } else {
        if (!this.editItem.port_id_meta.disposition) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select disposition'), 'Error')
          return
        }
        if (this.editItem.port_id_meta.type !== 5) {
          if (!this.editItem.port_id_meta.len) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Fill in the field length'), 'Error')
            return
          }
        }
        if (!this.editItem.port_id_meta.type) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select type'), 'Error')
          return
        }
        if (isNaN(Number(this.editItem.tec_id_meta.offset)) || Number(this.editItem.tec_id_meta.offset) < 0) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Fill in the field offset'), 'Error')
          return
        }
        this.editItem.port_id_meta.len = Number(this.editItem.port_id_meta.len)
        this.editItem.port_id_meta.offset = Number(this.editItem.port_id_meta.offset)
      }
      if (!this.editItem.isEnableTabRemoteID) {
        this.editItem.tec_id_meta.offset = 0
        this.editItem.tec_id_meta.len = 0
        this.editItem.tec_id_meta.type = 0
        this.editItem.tec_id_meta.disposition = 0
        this.editItem.tec_id_meta.regex = ''
      } else {
        if (!this.editItem.tec_id_meta.disposition) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select disposition'), 'Error')
          return
        }
        if (this.editItem.tec_id_meta.type !== 5) {
          if (!this.editItem.tec_id_meta.len) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Fill in the field length'), 'Error')
            return
          }
        }
        if (!this.editItem.tec_id_meta.type) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select type'), 'Error')
          return
        }
        if (isNaN(Number(this.editItem.tec_id_meta.offset)) || Number(this.editItem.tec_id_meta.offset) < 0) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Fill in the field offset'), 'Error')
          return
        }
        this.editItem.tec_id_meta.len = Number(this.editItem.tec_id_meta.len)
        this.editItem.tec_id_meta.offset = Number(this.editItem.tec_id_meta.offset)
      }
      if (!this.editItem.isEnableTabVlanID) {
        this.editItem.vlan_id_meta.offset = 0
        this.editItem.vlan_id_meta.len = 0
        this.editItem.vlan_id_meta.type = 0
        this.editItem.vlan_id_meta.disposition = 0
        this.editItem.vlan_id_meta.regex = ''
      } else {
        if (!this.editItem.vlan_id_meta.disposition) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select disposition'), 'Error')
          return
        }
        if (this.editItem.vlan_id_meta.type !== 5) {
          if (!this.editItem.vlan_id_meta.len) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Fill in the field length'), 'Error')
            return
          }
        }
        if (!this.editItem.vlan_id_meta.type) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select type'), 'Error')
          return
        }
        if (isNaN(Number(this.editItem.tec_id_meta.offset)) || Number(this.editItem.tec_id_meta.offset) < 0) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Fill in the field offset'), 'Error')
          return
        }
        this.editItem.vlan_id_meta.len = Number(this.editItem.vlan_id_meta.len)
        this.editItem.vlan_id_meta.offset = Number(this.editItem.vlan_id_meta.offset)
      }
      this.editItem.port_start_offset = Number(this.editItem.port_start_offset)
      this.editItem.profile_id = this.editItem.id
      let response = this.editItem.id !== 0
        ? this.$store.dispatch('Inventory/UPDATE_SWITCH_TYPES', this.editItem)
        : this.$store.dispatch('Inventory/CREATE_SWITCH_TYPES', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Inventory/GET_SWITCH_TYPES')
          this.$refs.modalEditInventoryProfiles.hide()
          this.$root.$emit('makeToasts')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/inventory/inventoryProfiles/editModal.vue